import { AccountConstants } from "finhelper";

export interface AccountLike {
    account_name?: string | null;
    [key: string]: any;
}

export default class FilterAccount {
    static ACCOUNT_BANKS = [
        AccountConstants.ATON_BROKER,
        AccountConstants.TINKOFF_BROKER,
    ];

    static filterBrokers(item: AccountLike): boolean {
        return item.account_name === null ||
            item.account_name === "Нет названия" ||
            (item.account_name !== "Атон" && item.account_name !== "Тинькофф брокер");
    }
}
